<template>
  <div class="w-full bg-white">
    <el-container class="h-full">
      <el-container>
        <el-header height="45px" class="border-b flex items-center justify-end">
          <el-button icon="el-icon-folder-opened" size="small" type="primary" :loading="loading" @click="onSave">
            保存
          </el-button>
        </el-header>
        <el-main>
          <el-table
            :key="tableData.key"
            v-loading="tableLoading"
            :data="tableData.data"
          >
            <el-table-column v-for="item in tableData.headers" :key="item.prop" :label="item.text" :prop="item.prop" />
          </el-table>
        </el-main>
        <el-footer height="45px" class="border-t justify-end flex items-center">
          <el-pagination
            :page-sizes="[100, 200, 300, 400]"
            :page-size="100"
            layout="total, jumper, prev, next"
            :total="400"
          />
        </el-footer>
      </el-container>
      <el-aside width="300px" class="border-l aggregate-config">
        <el-form label-position="top" class="px-3 config-content">
          <el-form-item label="数据来源">
            <el-select v-model="table.forms[0]" class="w-full" size="small" @change="onFormChange">
              <el-option v-for="item in forms" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <div slot="label">
              <div class="flex flex-row justify-between h-10">
                <span>聚合字段</span>
                <div v-if="currentForm !== undefined">
                  <el-popover
                    placement="bottom-start"
                    width="230"
                  >
                    <div slot="reference" class="h-full flex items-center">
                      <i
                        class="bi bi-plus text-2xl text-[#409EFF]"
                      />
                    </div>
                    <ul class="max-h-[150px] overflow-y-auto">
                      <li
                        v-for="item in currentFields" :key="item.name"
                        class="cursor-pointer items-center h-8 overflow-hidden px-[6px]"
                        :class="{'opacity-50': table.xFields.filter((i) => i.name === item.name).length > 0}"
                        @click="onXFieldAdd(item)"
                      >
                        {{ item.text }}
                      </li>
                    </ul>
                  </el-popover>
                </div>
              </div>
            </div>
            <ul class="field-list">
              <draggable :list="table.xFields">
                <li v-for="(item, index) in table.xFields" :key="index" class="field-item main-field group h-[30px]">
                  <div class="field-label relative group-hover:bg-[#ebf8fb]">
                    <div class="field-name overflow-hidden truncate cursor-move">
                      {{ item.text }}
                    </div>
                    <div class="edit-group absolute right-0 top-0 invisible group-hover:visible bg-[#ebf8fb]">
                      <i class="bi bi-trash mx-1 cursor-pointer" @click="() => {table.xFields.splice(index, 1)}" />
                    </div>
                  </div>
                </li>
              </draggable>
            </ul>
          </el-form-item>
          <el-form-item>
            <div slot="label">
              <div class="flex flex-row justify-between items-center h-10">
                <span>指标</span>
                <div>
                  <el-popover
                    placement="bottom-start"
                    width="230"
                  >
                    <div slot="reference" class="h-full flex items-center">
                      <i
                        class="bi bi-plus text-2xl text-[#409EFF]"
                      />
                    </div>
                    <ul class="max-h-[150px] overflow-y-auto">
                      <li
                        v-for="item in currentFields" :key="item.name"
                        class="cursor-pointer items-center h-8 overflow-hidden px-[6px]"
                        :class="{'opacity-50': table.valueFields.filter((i) => i.name === item.name).length > 0}"
                        @click="onValueFieldAdd(item)"
                      >
                        {{ item.text }}
                      </li>
                    </ul>
                  </el-popover>
                </div>
              </div>
            </div>
            <ul class="field-list">
              <draggable :list="table.valueFields">
                <li
                  v-for="(item, index) in table.valueFields" :key="index"
                  class="field-item main-field group h-[30px]"
                >
                  <div class="field-label relative group-hover:bg-[#ebf8fb]">
                    <div class="field-name overflow-hidden truncate cursor-move">
                      {{ item.text }}
                    </div>
                    <div class="edit-group absolute right-0 top-0 invisible group-hover:visible bg-[#ebf8fb]">
                      <el-radio-group v-model="item.count_type" size="mini">
                        <el-radio-button label="sum">求和</el-radio-button>
                        <el-radio-button label="avg">平均</el-radio-button>
                      </el-radio-group>
                      <i class="bi bi-trash mx-1 cursor-pointer" @click="() => {table.valueFields.splice(index, 1)}" />
                    </div>
                  </div>
                </li>
              </draggable>
            </ul>
          </el-form-item>
        </el-form>
      </el-aside>
    </el-container>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Draggable from 'vuedraggable'
import axios from 'axios'
import zroute from '../../ziggy'
import {debounce} from 'lodash/function'

export default {
  name: 'Edit',
  components: {Draggable},
  layout: Layout,
  props: {
    forms: {
      type: Array,
      default: () => [],
    },
    aggregate: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      data: {},
      tableLoading: false,
      loading: false,
      table: this.aggregate,
      tableData: {data: [], headers: [], key: Date.now()},
    }
  },
  computed: {
    currentForm() {
      if (this.table.forms.length === 0) {
        return null
      }
      return this.forms.find(item => item.id === this.table.forms[0])
    },
    currentFields() {
      if (this.table.forms.length === 0) {
        return []
      }
      const form = this.forms.find(item => item.id === this.table.forms[0])
      if (!form) {
        return []
      }
      return form.fields
    },
  },
  watch: {
    table: {
      handler: debounce(function (e) {
        this.getPreview()
      }, 500),
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getTableData() {
      var headers = []
      var data = []
      if (Object.keys(this.data.data).length > 0) {
        this.data.xFields.forEach((item) => {
          headers.push({...item, prop: 'x_' + item.name})
        })
        this.data.valueFields.forEach((item) => {
          headers.push({...item, prop: 'value_' + item.name})
        })
        if (this.data.data.val.length > 0) {
          data = this.data.data.val[0].data.map((item, index) => {
            // {'f_1': '1', 'f_2': '2'}
            var _data = {}
            this.data.xFields.forEach((_item, _index) => {
              _data['x_' + _item.name] = this.data.data.x[_index].data[index]
            })
            this.data.valueFields.forEach((_item) => {
              _data['value_' + _item.name] = this.data.data.val.find((i) => i.tag === _item.tag).data[index]
            })
            return _data
          })
        }
      }
      return {data: data, headers: headers, key: Date.now()}
    },
    onFormChange() {
      this.table.xFields = []
      this.table.valueFields = []
    },
    tableChange: function (val) {
      console.log('table changed', val)
    },
    onClick: function (val) {
      console.log('click', val)
    },
    onSave() {
      this.loading = true
      axios.post(zroute('app.aggregate.update', [zroute().params.app_id, zroute().params.aggregate_id]), this.table).then(res => {
        this.loading = false
        this.$message.success('保存成功')
      })
    },
    onValueFieldAdd(item) {
      let exist = this.table.valueFields.filter(field => field.name === item.name)
      if (exist.length > 0) {
        exist.map(field => {
          this.table.valueFields.splice(this.table.valueFields.indexOf(field), 1)
        })
      } else {
        this.table.valueFields.push({
          'tag': 'f_' + Date.now(),
          'id': this.currentForm.id,
          'name': item.name,
          'text': item.text,
          'type': item.type,
        })
      }
    },
    onXFieldAdd(item) {
      let exist = this.table.xFields.filter(field => field.name === item.name)
      if (exist.length > 0) {
        exist.map(field => {
          this.table.xFields.splice(this.table.xFields.indexOf(field), 1)
        })
      } else {
        this.table.xFields.push({
          'tag': 'f_' + Date.now(),
          'id': this.currentForm.id,
          'name': item.name,
          'text': item.text,
          'type': item.type,
          'count_type': 'sum',
        })
      }

    },
    getPreview: function () {
      console.log('get preview')
      this.tableLoading = true
      axios.post(zroute('app.aggregate.preview', [zroute().params.app_id, zroute().params.aggregate_id]), this.table).then(res => {
        this.tableLoading = false

        this.data = res.data
        console.log(this.data)

        this.tableData = this.getTableData()
        console.log(this.tableData)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.aggregate-config {
  ::v-deep .config-content.el-form {
    padding: 10px;

    .el-form-item__label {
      padding: 0;
      font-weight: 500;
    }

    .el-form-item {
      border-bottom: solid 1px #e1e1e1;
      padding-bottom: 10px;

      .el-form-item__label {
        width: 100%;
      }
    }

    .config-pattern-input {
      .el-input-group__prepend, .el-input-group__append {
        padding: 0 8px;
      }
    }
  }
}

.el-main {
  padding: 0;
}
</style>
